module.exports = __webpack_public_path__ + "media/images/logos/windeurope-ec2021-3886d1080f25b09090cd3edab6165d89.svg";